var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"crear-categoria","title":"Crear categoría"},on:{"close":() => _vm.close()}},[_c('FormComponent',{attrs:{"categoria":_vm.categoria,"loading":_vm.loading},on:{"terminado":_vm.crearCategoria}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }